export default __webpack_public_path__ + "static/media/facebookIcon.35b83071.png";